<template>
  <v-dialog
    @click:outside="close"
    @keydown.esc="close"
    v-model="show"
    max-width="900px"
    scrollable>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card class="pb-2">
        <div class="d-flex justify-end pr-3 pt-3">
          <v-icon @click="close" class="close-icon" size="30">
            mdi-close-circle-outline
          </v-icon>
        </div>
        <div v-if="isLoading" class="d-flex justify-center my-12">
          <v-progress-circular :width="4" color="primary" indeterminate />
        </div>
        <template v-else>
          <v-card-title>
            <span class="headline">
              {{ agentId ? 'Uredi podatke o agentu' : 'Novi agent' }}
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-card class="px-4 pb-4 mb-2 mt-4 mx-4">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="agentData.firstName"
                    label="Ime" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="agentData.lastName"
                    label="Prezime" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="agentData.email"
                    :rules="[v => !!v || requiredMessage]"
                    label="Email" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="agentData.phone"
                    label="Telefon" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <profile-photo-upload
                    v-model="agentData.profilePhoto"
                    @delete="agentData.profilePhoto = null"
                    @uploaded="agentData.profilePhoto = $event"
                    :label="'Profilna slika'"
                    :propertyId="agentId" />
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mt-2 mb-2">
            <v-spacer></v-spacer>
            <v-btn @click="$emit('input', false)">
              Poništi
            </v-btn>
            <v-btn @click="save" :disabled="!valid" color="success">
              {{ agentId ? 'Spremi promjene' : 'Dodaj novog agenta' }}
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import api from '../../api/agent';
import cloneDeep from 'lodash/cloneDeep'
import ProfilePhotoUpload from './ProfilePhotoUpload';

export default {
  name: 'agent-dialog',
  props: {
    agent: { type: Object, default: null },
    agentId: { type: Number, default: null },
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      agentData: {
        email: null,
        firstName: null,
        lastName: null,
        phone: null,
        profilePhoto: null
      },
      isLoading: false,
      show: false,
      valid: true
    };
  },
  computed: {
    requiredMessage() {
      return 'Ovo polje je obavezno';
    }
  },
  methods: {
    ...mapActions('agents', ['create', 'update']),
    close() {
      this.$emit('input', false);
    },
    async getAgent() {
      this.isLoading = true;
      const agent = await api.get(this.agentId);
      this.agentData = cloneDeep(agent);
      this.initialAgentData = cloneDeep(agent);
      this.isLoading = false;
    },
    async save() {
      this.$refs.form.validate();
      this.$nextTick(async () => {
        if (!this.valid) return;
        const save = this.agentId ? this.update : this.create;
        await save(this.agentData);
        this.$emit('input', false)
      });
    }
  },
  created() {
    if (this.agentId) this.getAgent();
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.show = this.value;
      }
    }
  },
  components: { ProfilePhotoUpload }
}
</script>

<style lang="scss" scoped>
.filters-wrapper  {
  background-color: #ECEFF1;
}
</style>
